import axios from "axios";
import { BE_SERVER_ENDPOINT, API_PROTOCOL } from "../constants/configs.js";
import { TRANSLATION_ACTIONS } from "../actions/translationActions";
import { filterAndSetInMemTranslations } from "../helpers/helper.js";

const TranslationDataFetcher = {
  fetchAllTranslations: function(options) {
    return dispatch => {
      const version = options.isPublic ? 'v2.0' : '2.1';
      let url = `${API_PROTOCOL}${BE_SERVER_ENDPOINT}/${version}/`;
      if (options.isPublic) {
        url += 'public/string-resources/';
      } else {
        url += 'stringResources/';
      }
      url += `pilot/${options.pilotId}?locale=${options.locale}&tag=${options.tagType}`;
      if (options.module) {
        url += `&module=${options.module}`;
      }

      axios.get(url, {
        handlerEnabled: !options.isPublic
      })
        .then(response => {
          filterAndSetInMemTranslations(response.data.payload);
          dispatch({
            type: TRANSLATION_ACTIONS.FETCH_ALL_TRANSLATIONS_DATA_SUCCESS,
            payload: response.data.payload
          });
        });
    };
  }
};

export default TranslationDataFetcher;
